export const SET_FILTERED_SEARCH_RESULTS = "SET_FILTERED_SEARCH_RESULTS";

export const setFilteredSearchResults = (filteredResults) => ({
    type: SET_FILTERED_SEARCH_RESULTS,
    payload: filteredResults,
});